import React from "react";

const AdminProfile = () => {
  return <div className="adminprofile">Admin Profile</div>;
};

export default AdminProfile;
